/* src/app/private/components/roll-number/create-roll-number/create-roll-number.component.scss */
.field {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 1rem;
}
label {
  font-weight: 500;
  margin-bottom: 5px;
  font-size: 14px;
  color: #374151;
}
.p-error {
  font-size: 12px;
  color: red;
}
small.text-red-500 {
  font-size: 12px;
  color: #ef4444;
  margin-top: 4px;
}
small.text-gray-500 {
  font-size: 12px;
  color: #6b7280;
}
/*# sourceMappingURL=create-roll-number.component.css.map */
